/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/drafts/rfa-engineering-incidents.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/drafts/rfa-engineering-incidents.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/rfa-engineering-incidents.mdx';

const metadata = {
  slug: "rfa-engineering-incidents",
  title: "RFA: Engineering Incidents",
  author: "Christian Battaglia",
  description: "A proposal for structured incident management at Amplify — defining severity levels (SEV-1 through SEV-3), communication protocols, root cause analysis, and retrospective practices for when things go wrong in production.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2019-12-20T00:00:00.000Z",
  
  readTime: "2 min read",
  tags: ["incident management","SRE","Amplify","severity levels","root cause analysis","retrospectives","DevOps","software engineering","observability"],
};

export const Route = createFileRoute('/blog/posts/rfa-engineering-incidents')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/rfa-engineering-incidents',
    image: '/og/blog/rfa-engineering-incidents.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
